module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Yepstr","short_name":"Yepstr","start_url":"/","background_color":"#f5f5f6","theme_color":"#f59b24","display":"standalone","icon":"static/images/favicon.png","include_favicon":true},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-70032747-1","head":true,"anonymize":false,"respectDNT":true,"exclude":["/preview/**","/do-not-track/me/too/"],"pageTransitionDelay":0,"cookieDomain":"auto"},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-TV3573","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}}},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"181024245632288"},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-intercom-spa/gatsby-browser.js'),
      options: {"plugins":[],"app_id":"q4512h2t","include_in_development":true,"delay_timeout":1000},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://306beb9cff23406d8bbdbf0e44931665@sentry.io/1526120","environment":"production","enabled":true},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-theme-localization/gatsby-browser.js'),
      options: {"plugins":[],"languages":["sv","en"],"localesDir":"./src/locales","allowIndex":true,"defaultLng":"sv","namespaces":["translation"],"i18next":{"fallbackLng":[],"react":{"wait":true,"useSuspense":true},"debug":false},"i18nPlugin":{"langKeyDefault":"sv","prefixDefault":false,"useLangKeyLayout":false}},
    },{
      plugin: require('/opt/build/repo/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
